<template>
    <div class="columns settings is-multiline">
        <div class="column is-12">
            <div class="box">
                <h1 class="title"><i class="fa fa-house"></i> Ny Skola</h1>
            </div>
        </div>
        <div class="column is-12">
            <div class="box">
                <form @submit.prevent="createSchool" class="columns is-multiline">
                    <div class="column is-12">
                        <p>När du skapar en skola så skapas automatiskt lärarkonto och elevkonto samt de koder som
                            behövs för för att logga in.</p>
                    </div>
                    <div class="column is-6">
                        <div class="control">
                            <label for="name" class="label">Skolnamn*</label>
                            <input class="input" name="name" v-model="school.name" type="text"
                                   placeholder="Skolans namn" required>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="control">
                            <label for="description" class="label">Beskrivning</label>
                            <input class="input" name="description" v-model="school.description" type="text"
                                   placeholder="En beskrivning på skolan">
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="control">
                            <label for="client_name" class="label">Namn på lärare*</label>
                            <input class="input" name="client_name" v-model="school.client_name" type="text"
                                   placeholder="Namn på lärare" required>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="control">
                            <label for="client_email" class="label">E-post för lärare*</label>
                            <input class="input" name="client_email" v-model="school.client_email" type="email"
                                   placeholder="E-post för lärare">
                        </div>
                    </div>
                    <div class="column is-12">
                        <button type="submit" class="button button-primary">Skapa skola</button>
                    </div>
                </form>

            </div>
        </div>
    </div>
</template>

<script>
import modelMixin from '../mixins/model'

export default {
  name: 'NewScool',
  mixins: [modelMixin],
  data () {
    return {
      school: {
        name: '',
        description: '',
        client_name: '',
        client_email: ''
      }
    }
  },
  watch: {},
  methods: {
    createSchool: function () {
      const that = this
      this.$store.dispatch('newSchool', { data: this.school })
        .then((response) => {
          that.$router.push({ name: 'School', params: { id: response.data.School.id } })
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
  computed: {},
  mounted () {
  }
}
</script>
